// extracted by mini-css-extract-plugin
export default {"our-roots":"Roots_our-roots__+3BE8","title":"Roots_title__TRsji","heading":"Roots_heading__jSlLf","desc":"Roots_desc__Bnc8i"};